export default __webpack_public_path__ + "static/azure-4af610818c83c85bc559d51c4c319b41.png";